import {
    extendTemporaryAccessExpiry,
    grantTemporaryAdminAccess,
    grantTemporaryEmailAccess,
    ITemporaryAccessFormData,
    removeTemporaryAccess
} from "@pjs/user-domain";
import { ITemporaryAccessActions } from "./interfaces/ITemporaryAccessActions";

export const temporaryAccessActions: ITemporaryAccessActions = {
    grantTemporaryAccess: (details: ITemporaryAccessFormData, usingAdmin: boolean) => {
        if (usingAdmin) {
            return grantTemporaryAdminAccess(details);
        }

        return grantTemporaryEmailAccess(details);
    },
    revokeTemporaryAccess: removeTemporaryAccess,
    extendTemporaryAccess: extendTemporaryAccessExpiry
};
